
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DashboardLayoutHeader',
  computed: {
    headerData() {
      const routeName = this.$route.name
      const headers: Record<string, { icon: string; title: string }> = {
        'owner-policies': { icon: 'policies', title: 'Policies' },
        'owner-settings': { icon: 'settings', title: 'Settings' },
        'owner-members': { icon: 'users', title: 'Members' },
        'owner-reports': { icon: 'pie-chart', title: 'Reports' },
        'owner-repos': { icon: 'layers', title: 'Repositories' },
        'owner-knowledge': { icon: 'memory', title: 'Knowledge' }
      }

      for (const key in headers) {
        if (routeName?.includes(key)) {
          return headers[key]
        }
      }
      return null
    }
  }
})
